import React from 'react';
import './TopNav.scss';
import { FaRegBell } from 'react-icons/fa';
import { GoPerson } from 'react-icons/go';
import { IoIosArrowDown } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../Redux/OauthSlice';
import { removePersistance } from '../../../Helpers/helper';
const TopNav = ({ heading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.User);
  const item = [
    // {
    //   key: "home",
    //   label: "Home",
    // },
    // {
    //   key: 2,
    //   label: "Profile",
    // },
    {
      key: 'logout',
      label: 'Logout',
      danger: true,
    },
  ];
  const onClick = ({ key }) => {
    switch (key) {
      case 'home':
        alert('home');
        break;
      case 'logout':
        dispatch(logout());
        removePersistance();
        navigate('/login');
        break;
      default:
        alert('invalid key');
    }
  };
  return (
    <>
      <div
        className="Top-nav ml-3 pt-3 flex place-content-center  justify-between h-[10vh]   "
        style={{ width: '100%' }}
      >
        <div
          className="Dashboard-left m-2 text-xl "
          style={{ fontWeight: '500' }}
        >
          <h1>{heading}</h1>
        </div>
        <div className="Dashboard-right flex place-content-center m-1 ">
          {/* <span className="cart-icon text-2xl m-2.5">
            <FaRegBell />
            <span>1</span>
          </span> */}
          <span className="m-2.5 text-xl">
            <GoPerson />
          </span>
          <span className="text-l m-2.5" style={{ fontWeight: '500' }}>
            <h1>{user?.firstName}</h1>
          </span>
          <span className="text-xl m-2.5">
            <Dropdown
              menu={{
                items: item,
                onClick,
                style: {
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                },
              }}
              trigger={['click']}
              overlayStyle={{
                width: '7vw',
              }}
            >
              <IoIosArrowDown />
            </Dropdown>
          </span>
        </div>
      </div>
      {/* <div
        className="Top-nav ml-3 pt-3 flex place-content-center  justify-between h-[10vh]  "
        style={{ width: "85vw" }}
      >
        <div
          className="Dashboard-left m-2 text-xl "
          style={{ fontWeight: "500" }}
        >
          <h1>{heading}</h1>
        </div>
        <div className="Dashboard-right flex place-content-center m-1 ">
          <span className="cart-icon text-2xl m-2.5">
            <FaRegBell />
            <span>1</span>
          </span>
          <span className="m-2.5 text-xl">
            <GoPerson />
          </span>
          <span className="text-l m-2.5" style={{ fontWeight: "500" }}>
            <h1>Admin</h1>
          </span>
          <span className="text-xl m-2.5">
            <IoIosArrowDown />
          </span>
        </div>
      </div> */}
    </>
  );
};

export default TopNav;
